import { defineMessages } from 'react-intl';

export default defineMessages({
    buildingHeading: {
        id: "quoteandbind.wizard.commercial.TWIA.Building.Building",
        defaultMessage: "Building"
    },
    buildingID: {
        id: "quoteandbind.wizard.commercial.TWIA.Building.Building ID",
        defaultMessage: "Building ID"
    },
    buildingNum: {
        id: "quoteandbind.wizard.commercial.TWIA.Building.Building #",
        defaultMessage: "Building #"
    },
    unitNum: {
        id: "quoteandbind.wizard.commercial.TWIA.Building.Unit #",
        defaultMessage: "Unit #"
    },
    classCode: {
        id: "quoteandbind.wizard.commercial.TWIA.Building.Property Class Code",
        defaultMessage: "Property Class Code"
    },
    riskItemType: {
        id: "quoteandbind.wizard.commercial.TWIA.Building.Risk Item Type",
        defaultMessage: "Risk Item Type"
    },
    editBuilding: {
        id: "quoteandbind.wizard.commercial.TWIA.Building.Edit Building Details",
        defaultMessage: "Edit Building Details"
    }
})